<div [ngClass]="labelField.class" [class.lu-select__text]="selectedItem">
	{{ labelField.value }}
</div>
